import cx from 'classnames'
import style from './style.module.scss'
import { useContext } from 'react'
import TabContainer from 'components/Admin/Shared/Menu/Shared/TabContainer'
import { TabConfig } from 'components/Admin/Shared/Menu/types'
import { NavContext } from '../Shared/context'
import { useMyActiveSubscriptions } from 'hooks/subscriptions'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'
import {
  canAccessAdminBillingAndInvoices,
  canAccessAdminCoachesAndStaffPage,
  canAccessAdminContactInfoPage,
  canAccessAdminContactUsPage,
  canAccessAdminDirectoryPage,
  canAccessAdminHelpPage,
} from 'components/Auth/abilities'

export const directoryPageId = 'directory-page' as const
export const directoryPagePath = 'directory-page'

export const contactInfoId = 'contact-info' as const
export const contactInfoPath = 'contact-info'

export const billingInvoicesId = 'billing-and-invoices' as const
export const billingInvoicesPath = 'billing-and-invoices'

export const coachesAndStaffId = 'coaches-and-staff' as const
export const coachesAndStaffPath = 'staff'

export const helpId = 'help' as const
export const helpPath = 'help'

export const contactUsId = 'contact-us' as const
export const contactUsPath = 'contact-us'

export type CurrentTabType = TabConfig['id']

export default function Mobile() {
  const { navOpen, setNavOpen } = useContext(NavContext)
  const subscriptions = useMyActiveSubscriptions()
  const { selectedAffiliate } = useSelector(getMyAffiliates)
  const adminDirectoryPageAccess = canAccessAdminDirectoryPage(
    selectedAffiliate,
    subscriptions,
  )
  const adminContactInfoPageAccess = canAccessAdminContactInfoPage(
    selectedAffiliate,
    subscriptions,
  )
  const adminBillingAndInvoicesAccess = canAccessAdminBillingAndInvoices(
    selectedAffiliate,
    subscriptions,
  )
  const adminCoachesAndStaffPageAccess = canAccessAdminCoachesAndStaffPage(
    selectedAffiliate,
    subscriptions,
  )
  const adminHelpPageAccess = canAccessAdminHelpPage(
    selectedAffiliate,
    subscriptions,
  )
  const adminContactUsPageAccess = canAccessAdminContactUsPage(
    selectedAffiliate,
    subscriptions,
  )

  return (
    <>
      <div
        className={style.headerWrapper}
        onClick={() => setNavOpen((open) => !open)}
      ></div>
      <div className={cx(style.otherTabs, { [style.showOtherTabs]: navOpen })}>
        <nav className={style.tabs}>
          <div className={style.tabGroup}>
            {adminDirectoryPageAccess && (
              <TabContainer
                id={directoryPageId}
                onClick={() => setNavOpen((open) => !open)}
              />
            )}
            {adminContactInfoPageAccess && (
              <TabContainer
                id={contactInfoId}
                onClick={() => setNavOpen((open) => !open)}
              />
            )}
            {adminBillingAndInvoicesAccess && (
              <TabContainer
                id={billingInvoicesId}
                isExternalLink={true}
                onClick={() => setNavOpen((open) => !open)}
              />
            )}
            {adminCoachesAndStaffPageAccess && (
              <TabContainer
                id={coachesAndStaffId}
                onClick={() => setNavOpen((open) => !open)}
              />
            )}
          </div>
          <div className={style.tabGroup}>
            <div className={style.desktopLabel}>Resources</div>
            {adminHelpPageAccess && (
              <TabContainer
                id={helpId}
                onClick={() => setNavOpen((open) => !open)}
                isExternalLink
              />
            )}
            {adminContactUsPageAccess && (
              <TabContainer
                id={contactUsId}
                onClick={() => setNavOpen((open) => !open)}
                isExternalLink
              />
            )}
          </div>
        </nav>
      </div>
    </>
  )
}
